module.exports = __webpack_public_path__ + "img/CellCycle-PRCA_SpatialResearch.fb4388d7.png";